<template>
  <div class="card p-3 shadow-sm h-100">
    <div class="d-flex justify-content-between align-items-center mb-3">
      <div class="d-flex align-items-center gap-2">
        <i class="pi pi-users text-primary"></i>
        <span class="fw-semibold">Sesiones Activas (QR)</span>
      </div>
      <span class="badge bg-info text-white">
        {{ sessions?.length || 0 }} activas
      </span>
    </div>

    <!-- Lista o mensaje de vacío -->
    <div class="session-list mt-2 overflow-auto custom-scroll" style="scrollbar-width: none; -ms-overflow-style: none;">
      <template v-if="sessions && sessions.length > 0">
        <div
          v-for="(s, i) in sessions"
          :key="i"
          class="d-flex justify-content-between align-items-center border rounded-3 p-2 px-3 bg-light mb-2 hover-shadow-sm"
        >
          <div>
            <div class="fw-semibold text-dark">{{ s.table_name }}</div>
            <small class="text-muted">{{ s.minutes }} min</small>
          </div>
          <span
            class="badge text-capitalize fw-semibold px-3 py-1"
            :class="statusClass(s.status)"
          >
            {{ s.status }}
          </span>
        </div>
      </template>

      <!-- Mensaje cuando no hay sesiones -->
      <template v-else>
        <div class="text-center text-muted py-4">
          <i class="pi pi-clock me-2"></i>
          No hay sesiones activas en este momento
        </div>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  name: "SessionsPanel",
  props: {
    sessions: { type: Array, default: () => [] },
  },
  methods: {
    statusClass(status) {
      const s = status?.toLowerCase();
      if (s === "pidiendo") return "bg-primary-subtle text-primary";
      if (s === "esperando") return "bg-warning-subtle text-warning";
      if (s === "servida") return "bg-success-subtle text-success";
      if (s === "nueva") return "bg-dark text-white";
      return "bg-secondary-subtle text-secondary";
    },
  },
};
</script>

<style scoped>
.session-list {
  max-height: 420px;
}

.hover-shadow-sm:hover {
  background-color: #f1f3f5 !important;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);
}

.custom-scroll::-webkit-scrollbar {
  display: none;
}
</style>
